import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const FilledMapPin: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 0C2.24299 0 0 2.24298 0 4.99997C0 8.42148 4.47451 13.4445 4.66502 13.6566C4.84395 13.8559 5.15637 13.8556 5.33498 13.6566C5.52549 13.4445 10 8.42148 10 4.99997C9.99995 2.24298 7.75699 0 5 0ZM5 7.5156C3.61288 7.5156 2.4844 6.38709 2.4844 4.99997C2.4844 3.61285 3.6129 2.48437 5 2.48437C6.3871 2.48437 7.51557 3.61288 7.51557 5C7.51557 6.38712 6.3871 7.5156 5 7.5156Z"
        fill="currentColor"
      />
    </svg>
  )
})

FilledMapPin.displayName = 'FilledMapPin'
